import React from "react";

const GalleryIconDark = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M6.66602 7.08332C6.66602 6.95229 6.69239 6.88231 6.71 6.84819C6.72794 6.8134 6.75258 6.78536 6.78835 6.7596C6.82714 6.73167 6.8792 6.7068 6.94052 6.68928C7.00301 6.67143 7.05617 6.66666 7.08268 6.66666C7.10919 6.66666 7.16236 6.67143 7.22484 6.68928C7.28617 6.7068 7.33822 6.73167 7.37701 6.7596C7.41278 6.78536 7.43742 6.8134 7.45537 6.84819C7.47297 6.88231 7.49935 6.95229 7.49935 7.08332C7.49935 7.21435 7.47297 7.28434 7.45537 7.31846C7.43742 7.35325 7.41278 7.38129 7.37701 7.40704C7.33822 7.43497 7.28617 7.45984 7.22484 7.47737C7.16236 7.49522 7.10919 7.49999 7.08268 7.49999C7.05617 7.49999 7.00301 7.49522 6.94052 7.47737C6.8792 7.45984 6.82714 7.43497 6.78835 7.40704C6.75258 7.38129 6.72794 7.35325 6.71 7.31846C6.69239 7.28434 6.66602 7.21435 6.66602 7.08332Z"
        fill="#000000b3"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.16602 1.66666C2.7853 1.66666 1.66602 2.78594 1.66602 4.16666V12.6109C1.92889 12.5657 2.17357 12.5315 2.38483 12.5076C3.55213 12.3161 5.30757 12.2618 7.16137 12.6215C9.04374 10.6845 12.283 9.16666 17.4993 9.16666H18.3327V4.16666C18.3327 2.78594 17.2134 1.66666 15.8327 1.66666H4.16602ZM7.08268 4.99999C6.741 4.99999 6.24702 5.09564 5.81451 5.40704C5.33952 5.74904 4.99935 6.31172 4.99935 7.08332C4.99935 7.85492 5.33952 8.4176 5.81451 8.7596C6.24702 9.07101 6.741 9.16666 7.08268 9.16666C7.42437 9.16666 7.91835 9.07101 8.35085 8.7596C8.82585 8.4176 9.16602 7.85492 9.16602 7.08332C9.16602 6.31172 8.82585 5.74904 8.35085 5.40704C7.91835 5.09564 7.42437 4.99999 7.08268 4.99999Z"
        fill="#000000b3"
      />
      <path
        d="M18.3327 10.8333H17.4993C13.3056 10.8333 10.6761 11.8729 9.06776 13.1433C10.9396 13.8195 12.78 15.0195 14.0344 17.0502C14.2618 17.392 14.5418 17.8392 14.8257 18.3333H15.8327C17.2134 18.3333 18.3327 17.214 18.3327 15.8333V10.8333Z"
        fill="#000000b3"
      />
      <path
        d="M12.88 18.3333C12.7949 18.1988 12.714 18.0742 12.6393 17.9622C12.6367 17.9583 12.6341 17.9544 12.6315 17.9504C12.6286 17.9459 12.6258 17.9413 12.623 17.9367C11.3568 15.8793 9.31752 14.8234 7.26526 14.3473C5.4581 13.9282 3.70759 13.9768 2.63635 14.1553C2.62142 14.1578 2.60642 14.1599 2.59138 14.1616C2.32666 14.191 2.00442 14.239 1.66602 14.3054V15.8333C1.66602 17.214 2.7853 18.3333 4.16602 18.3333H12.88Z"
        fill="#000000b3"
      />
    </svg>
  );
};

export default GalleryIconDark;
